var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opacity-50 lg:opacity-100"},[_c('img',{attrs:{"src":`${_vm.$paths.assetsUrl}img/worldmap.svg`,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }